document.addEventListener("DOMContentLoaded", () => {
  const filtersButton = document.querySelector(".mobile-facets__open-wrapper");
  filtersButton.addEventListener('click', () => {
    const menuHeader = document.querySelector('.shopify-section-group-header-group');
    menuHeader.classList.remove('shopify-section-header-hidden');
  })
})